/** Float32 samples → per-frame RMS. Pure and synchronous: the same function
 * runs inside rmsFrames.worker.ts (normal path) and inline on the main thread
 * (fallback when workers are unavailable), exactly like pcmWav.ts. */
export function rmsFrames(samples: Float32Array, sampleRate: number, hop: number): Float32Array {
  const per = Math.max(1, Math.round(sampleRate * hop))
  const frames = Math.floor(samples.length / per)
  const out = new Float32Array(frames)
  for (let f = 0; f < frames; f++) {
    let sum = 0
    const from = f * per
    for (let i = from; i < from + per; i++) sum += samples[i] * samples[i]
    out[f] = Math.sqrt(sum / per)
  }
  return out
}

export interface RmsJob {
  samples: Float32Array
  sampleRate: number
  hop: number
}
